// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__t+DoI","footerText":"Footer_footerText__VMmqD"};